import { APY_DECIMALS, TEN } from '.';

export const DEFAULT_TARGET_YIELD = 15;

export const SCALED_APY = TEN ** BigInt(APY_DECIMALS);

export const DEFAULT_APY = (SCALED_APY * BigInt(DEFAULT_TARGET_YIELD) * BigInt(100)) / BigInt(10_000); // 15%
